module.exports = __webpack_public_path__ + "static/win_total_ratings-f0f95f185c2110a97a22fd9dd6309de5.jpeg";